import TimePickerField from './TimePickerField.vue';
import InfiniteTimePicker from './InfiniteTimePicker.vue';
import WheelColumn from './WheelColumn.vue';
import {
  createTimePickerConfig,
  defaultTimePickerConfig,
  getPickerThemeStyles,
  resolveDefaultTime,
} from './config';
import {
  buildRange,
  formatLegacyTime,
  formatTime,
  getCurrentTimeRounded,
  normalizeTime,
  parseTime,
} from './utils';

export {
  TimePickerField,
  InfiniteTimePicker,
  WheelColumn,
  defaultTimePickerConfig,
  createTimePickerConfig,
  resolveDefaultTime,
  getPickerThemeStyles,
  buildRange,
  formatLegacyTime,
  formatTime,
  getCurrentTimeRounded,
  normalizeTime,
  parseTime,
};

export function installTimePicker(Vue, config = {}) {
  const settings = createTimePickerConfig(config);
  Vue.prototype.$timePickerConfig = settings;
  Vue.component('TimePickerField', TimePickerField);
}

export default TimePickerField;
